export default __webpack_public_path__ + "static/bcorp-logo-en-225074f2b04bfeb92b6f92221a748766.png";